export default "__VITE_ASSET__DRK4kSPa__"